import React, { useState } from 'react';

import Button from 'CommonComponents/Button';

import EditIcon from 'Assets/icons/edit.svg';
import EyeIcon from 'Assets/icons/eye.svg';

export default function CommittedExpendituresIndexTableRow(props) {
    const [showVenues, setShowVenues] = useState(false);

    const internalClickRow = () => {
        setShowVenues(!showVenues);
    };

    const clickVenueRow = (committedExpensable) => {
        props.clickRow(props.committedExpenditure, committedExpensable);
    };

    return (
        <>
            <tr key={props.committedExpenditure.id} className={'cursor-pointer accounts-table-main-tr'}>
                <td>{props.committedExpenditure.expense?.name}</td>
                <td>{props.committedExpenditure.cashflow.total}</td>
                <td>{props.committedExpenditure.supplier != undefined ? props.committedExpenditure.supplier.name : '-'}</td>
                <td>{props.committedExpenditure.contract_reference != undefined ? props.committedExpenditure.contract_reference : '-'}</td>
                <td>
                    {props.committedExpenditure.expense?.type !== 'template' && props.committedExpenditure.expense?.assign === 'venue' && (
                        <Button small variant="secondary" className="m-1" onClick={() => internalClickRow()}>
                            <EyeIcon className="tw-w-3 tw-h-3 tw-mr-2" />
                            See Venues
                        </Button>
                    )}
                    {((props.committedExpenditure.expense?.type === 'expense' && props.committedExpenditure.expense?.assign === 'event') ||
                        props.committedExpenditure.expense?.type === 'template' ||
                        props.committedExpenditure.expense?.type === 'project' ||
                        props.committedExpenditure.expense?.type === 'sport') && (
                        <Button small variant="primary" className="m-1" onClick={() => props.clickRow(props.committedExpenditure)}>
                            <EditIcon className="tw-w-3 tw-h-3 tw-mr-2" />
                            Edit
                        </Button>
                    )}
                </td>
            </tr>
            {showVenues && (
                <tr>
                    <td colSpan={'5'}>
                        <table className={'table no-footer mb-0 p-0'}>
                            <thead>
                                <tr>
                                    <th style={{ width: '30%' }}>Venue</th>
                                    <th style={{ width: '10%' }}>Total</th>
                                    <th style={{ width: '20%' }}>Supplier</th>
                                    <th style={{ width: '20%' }}>Contract Reference</th>
                                    <th style={{ width: '20%' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!props.committedExpenditure.committed_expensables.length === 0 ? (
                                    <tr>
                                        <td colSpan="5">There are no venues committed at this expense</td>
                                    </tr>
                                ) : (
                                    props.committedExpenditure.committed_expensables.map((committedExpensable) => {
                                        return (
                                            <tr key={committedExpensable.id}>
                                                <td>{committedExpensable.venue.name}</td>
                                                <td>{committedExpensable.cashflow.total}</td>
                                                <td>{committedExpensable.supplier != undefined ? committedExpensable.supplier.name : '-'}</td>
                                                <td>{committedExpensable.contract_reference != undefined ? committedExpensable.contract_reference : '-'}</td>
                                                <td>
                                                    <small>
                                                        <button
                                                            type="button"
                                                            className="button small p-0 h-auto text-primary"
                                                            onClick={() => clickVenueRow(committedExpensable)}
                                                        >
                                                            <EditIcon className="tw-w-3 tw-h-3" />
                                                            Edit
                                                        </button>
                                                    </small>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}
        </>
    );
}
